/*
 * @Descripttion:调用支付接口的函数
 * @Author: congz
 * @Date: 2020-06-10 19:03:02
 * @LastEditors: congz
 * @LastEditTime: 2020-08-12 17:51:36
 */

import axios from 'axios'

// 初始化支付信息（旧FM支付）
const initPayment = form =>
  axios.post('/api/v1/payments', form).then(res => res.data)

// 初始化DeepPay在线支付
const initOnlinePayment = form =>
  axios.post('/api/v1/pay/init-online-pay', form).then(res => res.data)

export { initPayment, initOnlinePayment }
